import { useTranslation } from 'react-i18next';

import { SMSMarketingContainer } from '@/components/Containers/SMSMarketingContainer';
import { MarketingProductsProps } from '@/components/Products/EmailMarketingProducts';

export const SMSMarketingProducts = ({
  onRequestInfo,
  onProductSelect,
  products,
  steps,
  userProducts,
  countries = [],
  defaultSMSCountryProvider,
  smsCredits = { '--': '' },
  userIsLogged,
}: MarketingProductsProps) => {
  const { t } = useTranslation();
  const title = t('productTypes.smsMarketing.headerTitle');
  const marks = steps;
  const max = Object.keys(marks).length - 1;
  const onSliderChange = () => {};

  return (
    <SMSMarketingContainer
      title={title}
      products={products}
      max={max}
      onSliderChange={onSliderChange}
      onProductSelect={onProductSelect}
      onRequestInfo={onRequestInfo}
      marks={marks}
      selectMarks={marks}
      userProducts={userProducts}
      countries={countries}
      defaultSMSCountryProvider={defaultSMSCountryProvider}
      smsCredits={smsCredits}
      userIsLogged={userIsLogged}
    />
  );
};
